import Dialog from '@mui/material/Dialog';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { themeGet } from '@styled-system/theme-get';

import Text from '../../../shared/Text';
import Button from '../../../shared/Button';

import { useBroadcastContext } from '../contexts/BroadcastContext.jsx';
import { EMAIL, SMS } from '../utils/constants';

export const SendConfirmationModal = ({
  broadcastType,
  open,
  onClose,
  onSave,
}) => {
  const { t } = useTranslation('broadcasts');
  const { smsCount, emailCount } = useBroadcastContext();

  const countText = () => {
    if (broadcastType === EMAIL)
      return t('confirmationModal.pay.emailCount', {
        emailCount,
      });

    if (broadcastType === SMS)
      return t('confirmationModal.pay.smsCount', {
        smsCount,
      });

    return t('confirmationModal.pay.emailSmsCount', {
      smsCount,
      emailCount,
    });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <ModalWrapper>
        <Header>
          <Title>
            <Text variant="h5">{t('send')}?</Text>
          </Title>
        </Header>
        <Body>
          <Description>
            <Text variant="body1">{t('confirmationModal.body')}</Text>
          </Description>
          <CountDescription>
            <Text variant="body2">{countText()}</Text>
          </CountDescription>
        </Body>
        <Footer>
          <Button variant="black" mode="outline" onClick={onClose} width="100%">
            {t('confirmationModal.cancel')}
          </Button>
          <Button
            ml="10px"
            variant="primary"
            mode="contained"
            type="button"
            onClick={onSave}
            width="100%"
            data-cy="submitButton"
          >
            <SendIcon /> {t('confirmationModal.submit')}
          </Button>
        </Footer>
      </ModalWrapper>
    </Dialog>
  );
};

const ModalWrapper = styled.div``;

const Header = styled.div`
  padding: 24px 24px 10px 24px;
  display: flex;
  justify-content: space-between;
`;

const Title = styled.div``;

const Body = styled.div``;

const Footer = styled.div`
  display: flex;
  padding: 24px;
`;

const Description = styled.div`
  padding: 0px 24px 12px 24px;
`;

const CountDescription = styled.div`
  padding: 24px;
  border-top: 1px solid ${themeGet('colors.black.20')};
  border-bottom: 1px solid ${themeGet('colors.black.20')};
`;

const SendIcon = styled.i.attrs({
  className: 'fa-regular fa-paper-plane-top fa-lg',
})`
  margin-right: 5px;
  transform: rotate(315deg);
`;
